import { IsEditingMode } from 'components/visit-form/context/is-editing.context';
import { useContext } from 'react';

export const useIsEditMode = (): boolean => {
  return useContext(IsEditingMode);
};
